/**
 * @generated SignedSource<<aed8ed0f1129b320bae1030201320444>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentActiveWaitingPaymentMethodRoot_charge$data = {
  readonly availablePaymentMethods: ReadonlyArray<string | null | undefined> | null | undefined;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveWaitingPaymentMethodCreditCard_charge" | "PaymentActiveWaitingPaymentMethodPixCreditCard_charge" | "PaymentActiveWaitingPaymentMethod_charge">;
  readonly " $fragmentType": "PaymentActiveWaitingPaymentMethodRoot_charge";
};
export type PaymentActiveWaitingPaymentMethodRoot_charge$key = {
  readonly " $data"?: PaymentActiveWaitingPaymentMethodRoot_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveWaitingPaymentMethodRoot_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentActiveWaitingPaymentMethodRoot_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "availablePaymentMethods",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentActiveWaitingPaymentMethod_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentActiveWaitingPaymentMethodCreditCard_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentActiveWaitingPaymentMethodPixCreditCard_charge"
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "2554b6ccc7cf3e09066bff294e3077ae";

export default node;
